
export default function ProblemReframing() {
  return (
    <section className="py-24 bg-[#fafafa]">
      <div className="max-w-5xl mx-auto px-6">
        {/* Heading */}
        <h2 className="text-5xl font-bold text-center mb-8 leading-tight text-[#1a1a2e]" style={{ fontFamily: 'Noto Serif JP, serif' }}>
          1脚のオフィスチェアの選択が、<br />
          御社の生産性・離職率・採用力を<br />
          左右しているとしたら？
        </h2>

        {/* Body Copy */}
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <p className="text-base leading-relaxed text-[#4a4a4a]">
            「たかが椅子」と思われがちですが、座る時間は1日6〜8時間。<br />
            環境の質は、集中力・判断力・疲労回復に直結し、<br />
            結果として"見えない経営コスト"を生み続けています。
          </p>
        </div>

        {/* Before/After Comparison */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center relative">
          {/* Before Card */}
          <div className="bg-white rounded-2xl p-8 relative border border-[#e8e6e3]">
            <div className="absolute -top-4 left-8 bg-[#e07856] text-white text-sm font-bold px-4 py-2 rounded-full">
              Before
            </div>
            <h3 className="text-xl font-bold mb-6 mt-4 text-[#1a1a2e]">従来のオフィスチェア</h3>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-close-line text-xl text-[#e07856]"></i>
                </div>
                <span className="text-sm text-[#4a4a4a]">肩こり・腰痛による集中力低下</span>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-close-line text-xl text-[#e07856]"></i>
                </div>
                <span className="text-sm text-[#4a4a4a]">疲労の蓄積によるパフォーマンス低下</span>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-close-line text-xl text-[#e07856]"></i>
                </div>
                <span className="text-sm text-[#4a4a4a]">「働く環境が整っていない」印象によるエンゲージメント低下</span>
              </li>
            </ul>
            <div className="border-2 border-[#e07856] rounded-lg p-4 bg-[#e07856]/5">
              <p className="text-sm font-bold text-[#e07856]">結果：離職・採用コスト増（約100万円/人〜）</p>
            </div>
          </div>

          {/* Arrow */}
          <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 hidden md:block">
            <div className="bg-white rounded-full p-4 shadow-lg w-16 h-16 flex items-center justify-center border border-[#e8e6e3]">
              <i className="ri-arrow-right-line text-3xl text-[#8E7CC3]"></i>
            </div>
          </div>

          {/* After Card */}
          <div className="bg-white rounded-2xl p-8 shadow-lg relative border-2 border-[#8E7CC3]">
            <div className="absolute -top-4 left-8 bg-[#8E7CC3] text-white text-sm font-bold px-4 py-2 rounded-full">
              After
            </div>
            <h3 className="text-xl font-bold mb-6 mt-4 text-[#1a1a2e]">MeVER Chair（Core / Pro / Style）</h3>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-xl text-[#8E7CC3]"></i>
                </div>
                <span className="text-sm text-[#4a4a4a]">正しい姿勢と血流促進による集中力維持</span>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-xl text-[#8E7CC3]"></i>
                </div>
                <span className="text-sm text-[#4a4a4a]">回復まで設計された座り心地</span>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-xl text-[#8E7CC3]"></i>
                </div>
                <span className="text-sm text-[#4a4a4a]">「社員を大切にする会社」という明確なメッセージ</span>
              </li>
            </ul>
            <div className="border-2 border-[#8E7CC3] rounded-lg p-4 bg-[#8E7CC3]/5">
              <p className="text-sm font-bold text-[#8E7CC3]">結果：定着率向上・採用ブランディング強化</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
